import React, { useState, useRef } from "react";
import { Container, Col, Row } from "react-bootstrap";

// Import the ShareActionCard component
import ShareActionCard from "./ShareActionCard";

import "./IndividualStudentResultsOverview.css";
import "./ClassOverview.css";

import ReturnToClassResults from "./RetrunToClassResults";
import AllResultsHistory from "./AllResultsHistory"; // Import new component
import GradeCard from "./GradeCard";
import PrintAllStudentResults from "./PrintAllStudentResults";
import RecommendationsButton from "./RecommendationsButton";
import ReturnToSencoResults from "./ReturnToSencoResults";
import Suspense from "react";
import ReportCardPrintActionCard from "./ReportCardPrintActionCard";
import PrintAllStudentResultsModal from "./PrintAllStudentResultsModal";
import SENWatchlistButton from "./SENWatchlistButton";

function AllStudentResultsOverview(props) {
  const {
    classDetails = {}, // Provide a default empty object
    studentResults,
    assessmentResultsByStudent,
    schoolid,
    teacherid,
    classAssessments,
    teachers,
    assessment = {}, // Provide a default empty object
    students = [], // Provide a default empty array
    viewParent: initialViewParent,
    viewTeacher: initialViewTeacher,
    fromSencoResults,
    readingScores,
  } = props;

  // Safely access properties with optional chaining
  const gradeLevel1 = classDetails?.grade_level1;
  const gradeLevel2 = classDetails?.grade_level2;
  const trialClass = classDetails?.trial_class;

  const [toggleScoreType, setToggleScoreType] = useState("");
  const [showPrintCard, setShowPrintCard] = useState(false);
  const [printCardPosition, setPrintCardPosition] = useState({
    top: 0,
    left: 0,
  });

  // Add state for ShareActionCard
  const [showShareCard, setShowShareCard] = useState(false);
  const [shareCardPosition, setShareCardPosition] = useState({
    top: 0,
    left: 0,
  });

  // Initialize with props and create state setters
  const [viewParent, setViewParent] = useState(initialViewParent || false);
  const [viewTeacher, setViewTeacher] = useState(initialViewTeacher || false);

  const detailedRef = useRef(null);
  const overviewRef = useRef(null);
  const currentViewRef = useRef(null); // New ref to track the current view

  // Academic year ranges
  const YEAR_RANGES = {
    "24/25": { start: "2024-08-15", end: "2025-08-15" },
    "23/24": { start: "2023-08-15", end: "2024-08-15" },
    "22/23": { start: "2022-08-15", end: "2023-08-15" },
  };

  function getCurrentAcademicYear(date = new Date()) {
    const currentTimestamp = date.getTime();

    for (const [label, range] of Object.entries(YEAR_RANGES)) {
      const start = new Date(range.start).getTime();
      const end = new Date(range.end).getTime();

      if (currentTimestamp >= start && currentTimestamp < end) {
        return label;
      }
    }

    return "Unknown Year";
  }

  // Transform students array to match the format expected by ShareActionCard
  const formattedStudents = students.map((student) => ({
    id: student.id,
    name: student.name || student.student?.name,
  }));

  const academicYear = getCurrentAcademicYear();

  return (
    <>
      <Row className="inline-block align-items-center push-down">
        <Col className="col-auto">
          <ReturnToSencoResults />
        </Col>
        <Col className="flex-grow-1 text-center" style={{ margin: "10px" }}>
          <h2 className="page-description-header-results">
            {fromSencoResults ? "SENCO Results Overview" : "Results Overview"}
          </h2>
        </Col>
        <Col className="col-auto d-flex justify-content-end">
          {fromSencoResults && (
            <SENWatchlistButton
              schoolid={schoolid}
              teachers={teachers}
              teacherid={teacherid}
              assessment={assessment}
              readingScores={readingScores}
            />
          )}
          <button
            className="print-button"
            onClick={(event) => {
              const rect = event.currentTarget.getBoundingClientRect();
              setPrintCardPosition({
                top: rect.top + window.scrollY,
                left: rect.left - 250,
              });
              setShowPrintCard(!showPrintCard);
            }}
          >
            Print
            <img
              src={process.env.PUBLIC_URL + "/assets/imgs/chevron-sort.svg"}
              alt="Sort"
              className="print-button-icon"
            />
          </button>
          <button
            className="print-button"
            onClick={(event) => {
              const rect = event.currentTarget.getBoundingClientRect();
              setShareCardPosition({
                top: rect.top + window.scrollY,
                left: rect.left - 250,
              });
              setShowShareCard(!showShareCard);
            }}
          >
            Share
            <img
              src={process.env.PUBLIC_URL + "/assets/imgs/chevron-sort.svg"}
              alt="Sort"
              className="print-button-icon"
            />
          </button>
        </Col>
        <Col className="col-auto"></Col>{" "}
        {/* Empty column to balance the layout */}
      </Row>
      <div className="class-overview-container">
        <Container className="container-shape">
          <Row className="page-description-bar">
            <Col className="col-6">
              <Row>
                <Col className="col-6">
                  <h2
                    className="page-description-header"
                    style={{ whiteSpace: "nowrap" }}
                  >
                    {assessment.name?.split(" ")[1]} Report Cards
                  </h2>
                </Col>
              </Row>
            </Col>
            <Col className="col-4">
              <Row>
                <Col className="col-3"></Col>

                <Col className="col-1"></Col>
                <Col className="col-4">
                  {/* <RecommendationsButton onResultsPage={true} /> */}
                </Col>
              </Row>
            </Col>
          </Row>

          <hr />

          <Row>
            <Col className="col-3">
              <PrintAllStudentResults
                studentResults={studentResults}
                toggleScoreType={toggleScoreType}
                assessmentResultsByStudent={assessmentResultsByStudent}
                isPrintOut={true}
                detailedView={true}
                teacherid={teacherid}
                schoolid={schoolid}
                students={students}
                buttonName={"Print Detailed"}
                classDetails={classDetails}
                overviewRef={overviewRef}
              />
            </Col>
          </Row>

          {/* Render AllResultsHistory without any conditions */}
          <div
            ref={currentViewRef}
            style={{ minHeight: "100vh", position: "relative" }}
          >
            {/* Print-only header */}
            <div className="alpaca-print-header">
              <div className="printout-logo" />
              <div className="alpaca-print-header-text">
                <span className="alpaca-print-header-year">
                  School Year:{academicYear}
                </span>
              </div>
            </div>
            <AllResultsHistory
              studentResults={studentResults} // Pass the student results
              toggleScoreType={toggleScoreType}
              assessmentResultsByStudent={assessmentResultsByStudent}
              isPrintOut={false}
              detailedView={true}
              teacherid={teacherid}
              schoolid={schoolid}
              students={students}
              detailedRef={detailedRef}
              overviewRef={overviewRef}
              currentViewRef={currentViewRef} // Pass the new ref
              viewParent={viewParent}
              viewTeacher={viewTeacher}
              academicYear={academicYear}
            />
            {/* Print footer inside printable area */}
            {/* <div
              className="alpaca-print-footer"
              style={{
                position: "fixed",
                left: 0,
                bottom: 0,
                width: "100%",
                textAlign: "center",
                fontSize: "0.9rem",
                color: "#888",
                padding: "8px 0",
                background: "white",
                zIndex: 1000,
                display: "block",
              }}
            >
              Powered by ALPACA &copy; {new Date().getFullYear()}
            </div> */}
          </div>
        </Container>
      </div>
      {showPrintCard && (
        <ReportCardPrintActionCard
          cardPosition={printCardPosition}
          handleCloseCard={() => setShowPrintCard(false)}
          overviewRef={overviewRef}
          detailedRef={detailedRef}
          currentViewRef={currentViewRef} // Pass the new ref
          studentResults={studentResults}
          toggleScoreType={toggleScoreType}
          assessmentResultsByStudent={assessmentResultsByStudent}
          teacherid={teacherid}
          schoolid={schoolid}
          students={students}
          detailedView={true} // Pass detailedView as true
        />
      )}

      {/* Add ShareActionCard */}
      {showShareCard && (
        <ShareActionCard
          cardPosition={shareCardPosition}
          handleCloseCard={() => setShowShareCard(false)}
          activeAccordionStudents={formattedStudents}
          shareResults={(zipBlob) => {
            console.log("Sharing ZIP Blob:", zipBlob);
            // Add logic to handle sharing the ZIP blob
          }}
          assessmentName={assessment?.name || "Assessment"}
          className={classDetails?.name || "Report Cards"}
          rollNumber={schoolid || "School"}
          setViewParent={setViewParent}
          setViewTeacher={setViewTeacher}
          schoolid={schoolid}
          teacherId={teacherid}
          assessmentId={assessment?.id}
        />
      )}
    </>
  );
}

export default AllStudentResultsOverview;
